import { HalfMoon } from "iconoir-react";
import { Outlet } from "react-router-dom";
import artwork from "@/assets/account-ribbon.webp";
import { Brand } from "@/components/patterns/brand";
import { IconButton } from "@/components/ui/icon-button";
import { Icon } from "@/design-system/icons/icon";
import { useTheme } from "@/design-system/theme/theme-provider";
import { m } from "@/i18n/en";

export function AuthLayout() {
  const { appearance, setAppearance } = useTheme();
  return (
    <div className="min-h-screen bg-canvas">
      <header className="flex h-[var(--layout-header)] items-center justify-between px-5 sm:px-7">
        <Brand />
        <IconButton
          label={m.theme.quickTheme}
          onClick={() =>
            setAppearance(appearance === "dark" ? "light" : "dark")
          }
        >
          <Icon glyph={HalfMoon} />
        </IconButton>
      </header>
      <main className="mx-auto grid min-h-[calc(100vh-var(--layout-header))] max-w-[980px] items-center gap-6 px-5 py-8 md:grid-cols-[432px_minmax(0,524px)] md:px-0">
        <div
          aria-hidden
          className="hidden h-[620px] overflow-hidden rounded-[var(--radius-xl)] bg-primary-subtle md:block"
        >
          <img alt="" className="size-full object-cover" src={artwork} />
        </div>
        <div className="w-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
